import { atom } from "recoil"
import { MatchingOffersModel } from "../../../types/matching/matchingOfferModel"

export const favOffersState = atom<MatchingOffersModel[]>({
  key: "atoms/matching/favOffersState",
  default: [],
})
